var React = require('react');
var ReactNative = require('react-native');

var {
  View,
} = ReactNative;

var FeedPlusSideView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      showOnlyTappable: false
    }
  },

  getInitialState : function()
  {
    return {
      isVisible:true,
      scale: .9,
      opacity: .5,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  setAmountIn : function(amountIn)
  {
    var scale = Math.max(Math.min(1,amountIn), .9);
    if( scale != this.state.scale ) this.setState({scale});
    this.state.scale = scale;

    var opacity = Math.max(Math.min(1,amountIn), .5);
    if( opacity != this.state.opacity ) this.setState({opacity});
    this.state.opacity = opacity;
  },

  setVisible: function(isVisible)
  {
    if( this.state.isVisible != isVisible ) this.setState({isVisible})
  },

  render: function()
  {
    if( this.state.isVisible == false ) return null;

    var {style, ...otherProps} = this.props;

    return(
      <View pointerEvents={"box-none"} style={[this.props.style, {transform: [
            { scale: this.state.scale},
          ], opacity: this.state.opacity}]} {...otherProps} />
        )
  }
});
module.exports = FeedPlusSideView;
